<template>
  <v-app>
    <v-app-bar :dark="!isSandbox" app height="50">
      <v-img :src="`${hotelLogo}`" class="mx-2 me-2" contain max-width="140" />

      <!-- left-hand menu area -->
      <v-toolbar-items class="header_menu__wrapper" data-ktznta="163">
        <div v-for="(menu, i) in headerMenus" :key="i" class="header_menu__item" data-ktznta="164">
          <div
            v-if="menu.type === 'stem'"
            :class="(currentMenu === menu.code ? 'activeMenu ' : '') + 'pointer'"
            data-ktznta="165"
            @click="gotoEachMenu(menu.code)"
            v-text="$t(menu.label)"
          />
          <v-menu v-else bottom offset-y open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <span
                  :class="{ activeMenu: menu.codes.indexOf(currentMenu) !== -1 }"
                  data-ktznta="166"
                  v-text="$t(menu.label)"
                />
                <v-icon>arrow_drop_down</v-icon>
              </span>
            </template>

            <v-list>
              <v-list-item
                v-for="(item, j) in menu.menus"
                :key="j"
                :class="!checkMenuAvailability(item) ? 'pointer pa-0' : 'pa-0'"
                :style="checkMenuAvailability(item) ? 'position: relative; cursor: unset !important;' : ''"
                data-ktznta="167"
                @click="checkMenuAvailability(item) ? null : gotoEachMenu(item.code)"
              >
                <v-list-item-title :aria-disabled="item.isDisable" class="px-4" v-text="$t(item.label)" />
                <div
                  v-if="checkMenuAvailability(item)"
                  style="
                    width: 100%;
                    height: 100%;
                    background: rgba(158, 158, 158, 0.18);
                    z-index: 9999;
                    position: absolute;
                  "
                ></div>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-toolbar-items>

      <div v-if="isSandbox" class="me-4 d-flex align-center" style="position: relative; width: 135px; height: 100%">
        <v-btn v-if="!showLocQr" outlined style="color: #e95532" @click="showLocQr = true">
          {{ $t("show_qr_code") }}
        </v-btn>

        <div v-if="showLocQr" class="location_qr d-flex align-center flex-column text-center">
          <div class="d-flex align-center justify-space-between px-2 mt-2" style="min-width: fit-content; width: 100%">
            <label style="font-size: 16px; min-width: fit-content">{{ $t("scan_with_your_phone") }}</label>
            <v-icon color="#c2c2c2" @click="showLocQr = false">mdi-close-circle</v-icon>
          </div>
          <a :href="locationQr" style="width: 100%" target="_blank">
            <v-img :src="locationQr" class="location_qr-img" />
          </a>
          <a
            v-if="guestUrl"
            :href="guestUrl"
            class="mb-2"
            style="min-width: fit-content; font-size: 16px"
            target="_blank"
            >{{ $t("open_link_in_new_tab") }}</a
          >
        </div>
      </div>

      <!-- right-hand icon  area -->
      <div class="headerRight">
        <p class="text-no-wrap ms-5" v-text="tenantName" />
        <v-tooltip v-if="dashboardUrl.url != '' && dashboardUrl.isDisplay == true" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :dark="!isSandbox"
              class="iconButton ms-5"
              color="#4B8CE2"
              height="25px"
              icon
              v-bind="attrs"
              width="25px"
              @click="forwardTo(dashboardUrl.url)"
              v-on="on"
            >
              <v-icon size="25px">bar_chart</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("icon_dashboard") }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :dark="!isSandbox"
              class="iconButton ms-5"
              color="#4B8CE2"
              data-ktznta="159"
              height="25px"
              icon
              v-bind="attrs"
              width="25px"
              @click="forwardTo(manualUrl)"
              v-on="on"
            >
              <v-icon size="25px">question_mark</v-icon>
            </v-btn>
          </template>
          <span data-ktznta="160">{{ $t("common_help_center") }}</span>
        </v-tooltip>

        <v-menu nudge-bottom="4px" offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn :dark="!isSandbox" class="ms-5" data-ktznta="161" icon small v-on="on">
              <v-icon size="40px" style="color: #e2f0f7; background: #272727">mdi-account-circle</v-icon>
            </v-btn>
          </template>
          <div class="d-flex flex-column py-3 px-2">
            <div v-if="!isSandbox" style="color: grey; padding-bottom: 4px">
              {{ accountName }}
            </div>
            <div
              class="signout-button pointer"
              data-ktznta="162"
              @click="showLogoutDialog = true"
              v-text="$t('sign_out')"
            />
          </div>
        </v-menu>
      </div>
    </v-app-bar>

    <div class="system-error-notice" @click="dialogSystemError = true">
      <SystemErrorNotice onlyTitleInError="true" />
    </div>

    <v-main>
      <!-- loading, so allow navigation -->
      <div v-if="isLoading" class="layout-loader">
        <v-progress-circular :size="64" indeterminate></v-progress-circular>
      </div>
      <progress-circular :controls="isSaving"></progress-circular>

      <router-view />
    </v-main>

    <v-dialog v-model="dialogSystemError" max-width="700" width="50%">
      <v-card>
        <div class="pa-5">
          <SystemErrorNotice />
        </div>

        <v-card-actions class="pb-5">
          <v-spacer />
          <KtznAdminButton :label="$t('close')" @onClick="dialogSystemError = false" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Shown after the logout button was clicked, before the logout -->
    <KtznAdminCommonDialog
      v-model="showLogoutDialog"
      :btnTextProp="{ text1: $t('cancel'), text2: $t('ok') }"
      :dialogProp.sync="showLogoutDialog"
      :persistent="true"
      :textProp="$t('admin_confirm_logout')"
      :titleProp="$t('confirm')"
      @buttonOneEvent="showLogoutDialog = false"
      @buttonTwoEvent="logOutUser"
      @dialogState="showLogoutDialogState"
    />

    <!-- Shown when there are unsaved UI changes while switching between header menus -->
    <KtznAdminCommonDialog
      v-model="dialog"
      :btnTextProp="{ text1: $t('biz_admin_header_yes'), text2: $t('biz_admin_header_no') }"
      :dialogProp.sync="dialog"
      :titleProp="$t('biz_admin_header_message_leaving')"
      @buttonOneEvent="proceed"
      @buttonTwoEvent="dialog = false"
      @dialogState="dialogState"
    />

    <!-- Shown to sandbox users only -->
    <SandboxLogoutDialog
      v-if="isSandbox"
      v-model="sandboxLogoutDialog"
      :dialogProp.sync="sandboxLogoutDialog"
      @dialogState="sandboxLogoutDialogState"
      @logOut="logOutSandBox"
    />

    <v-dialog v-model="importInprogressNotification" max-width="290" persistent>
      <v-card>
        <v-card-text class="pa-4 font-weight-bold">{{ $t("import_in_progress") }}</v-card-text>
        <v-card-text class="pb-6 px-4">{{ $t("import_in_progress_notification") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#E95532" style="color: white" @click="closeNotification()">{{ $t("ok") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="importProgressNotification" max-width="290" persistent>
      <v-card>
        <v-card-text class="pa-4 font-weight-bold">{{ $t("import_complete") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#E95532" style="color: white" @click="importProgressNotification = false">{{ $t("ok") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script lang="ts">
import { computed, createComponent, onBeforeDestroy, onCreated, value, watch, Wrapper } from "vue-function-api";
import { getDefaultLocationGroup, loadHeaderMenus } from "@/modules/admin/services/hotelAdmin";
import { isSamoon } from "@/framework/utilities/isSamoon";
import { err } from "neverthrow";
import { HeaderMenu, QueryTenant, SubHeaderMenu } from "@/modules/admin/objects/hotelAdmin";
import { AuthenticationRepository } from "@/framework/repositories/authenticationRepository";
import { TenantService } from "@/framework/api/Admin/TenantService";
import { ErrorService } from "@/framework/errors/ErrorService";
import { BigQueryDashboardUrlResponse, ImportProcessResult } from "@/framework/network/gql/generated/graphql";
import { SandboxService } from "@/framework/api/Admin/SandboxService/SandboxService";
import { DictionaryService } from "@/framework/api/Admin/DictionaryService";
import { UserService } from "@/modules/auth/services/UserService";
import CustomError from "@/framework/errors/CustomError";
import { i18n } from "@/framework/plugins/i18n";
import { Mutation as HotelMutation } from "@/framework/store/hotel/types";
import store from "@/store";
import router from "@/router/router";
import SystemErrorNotice from "@/framework/components/SystemErrorNotice.vue";
import SandboxLogoutDialog from "@/views/admin/sandbox/SandboxLogoutDialog.vue";
import KtznAdminButton from "@/framework/components/common/KtznAdminButton.vue";
import KtznAdminCommonDialog from "@/framework/components/common/KtznAdminCommonDialog.vue";
import ProgressCircular from "@/framework/components/ProgressCircular.vue";

export default createComponent({
  components: {
    SystemErrorNotice,
    SandboxLogoutDialog,
    KtznAdminButton,
    KtznAdminCommonDialog,
    ProgressCircular,
  },
  setup(props, context) {
    const tenantService = new TenantService();
    const errorService = new ErrorService();
    const userService = new UserService();
    const $router = context.root.$router;
    const $route = context.root.$route;
    // TODO replace after SM refactor in helper file
    const hotelLogo = isSamoon() ? "../img/admin/samoon_logo.svg" : require("@/framework/assets/hotel/hotel-logo.svg");
    const currentMenu: Wrapper<string> = value("hotel_admin_function");
    const selectedMenu: Wrapper<string> = value("");
    const dialog: Wrapper<boolean> = value(false);
    const dialogSignOut: Wrapper<boolean> = value(false);
    const sandboxLogoutDialog: Wrapper<boolean> = value(false);
    const dialogSystemError = value(false);
    const tenantCd: Wrapper<string> = value("");
    const tenantName = value("");
    const accountName: Wrapper<string> = value("");
    const headerMenus: Wrapper<HeaderMenu[]> = value([]);
    const locationQr = value("");
    const isSandbox = value(false);
    const authenticationRepository = new AuthenticationRepository();
    const sandboxLogoutDialogState = (val: boolean) => (sandboxLogoutDialog.value = val);
    const dialogState = (val: boolean) => (dialog.value = val);
    const inProgressNotification = value(false);
    const isLoading = value(false);
    const isSaving = value({ shows: false });
    const importInprogressNotification = computed(
      () => inProgressNotification.value,
      () => {}
    );
    const waitingForImportProcessByOthers = value(false);
    const importProgressNotification = value(false);

    const showLocQr = value(false);
    const showLogoutDialog = value(false);
    const showLogoutDialogState = (val: boolean) => (showLogoutDialog.value = val);

    const guestUrl = value("");
    const manualUrl = computed(() => {
      return "https://in-room.manual.kotozna.com/" + (i18n.locale == "ja" ? "ja/" : "") + "home";
    });
    const dashboardUrl: Wrapper<BigQueryDashboardUrlResponse> = value({ url: "", isDisplay: false });
    let watcherInterval: any = null;

    watch(
      () => store.getters.isLoading,
      (newVal, oldVal) => {
        if (newVal != oldVal) isLoading.value = newVal;
      }
    );

    watch(
      () => store.getters.isSaving,
      (newVal, oldVal) => {
        if (newVal != oldVal) isSaving.value.shows = newVal;
      }
    );

    const checkMenuAvailability = (item: SubHeaderMenu) => {
      // To check if we need to disable the menu based on the condition, as of now there is one condition only for admin
      // >> if another user in the tenant is importing to the dictionary, we need to disable some menus
      // >> Menu Screen + Uniques words setting + Translation result/edit
      if (item.hasDisableCondition) {
        return store.getters.getIsImportInProgress;
      }
    };

    const gotoEachMenu = (menu: string) => {
      if (menu === currentMenu.value) return;

      selectedMenu.value = menu;
      const changed: boolean = store.getters.adminChanged || store.getters.adminSubChanged;
      if (changed) {
        dialog.value = true;
      } else if (menu === "conversations") {
        const routeData = context.root.$router.resolve({
          name: selectedMenu.value,
        });
        window.open(routeData.href, "_blank");
      } else {
        proceed();
      }
    };

    const proceed = () => {
      store.commit(HotelMutation.SET_ADMIN_CHANGED, false);
      store.commit(HotelMutation.SET_ADMIN_SUB_CHANGED, false);
      currentMenu.value = selectedMenu.value;
      dialog.value = false;
      $router.push({ path: `/${i18n.locale}/${selectedMenu.value}` });
    };

    const signOutAdmin = async () => {
      await authenticationRepository.signOutUser(true);
    };

    const logOutSandBox = async (note: string) => {
      try {
        if (note.trim().length) {
          const res = await new SandboxService().updateSandboxLogoutNote(note);
          if (res.isErr()) {
            return await errorService.handleError(res.error);
          }
        }
        await authenticationRepository.signOutUser(true);
      } catch (e) {
        throw err(new CustomError(CustomError.Type.general, e, "HotelAdmin - logOutSandBox"));
      }
    };

    const logOutUser = async () => {
      try {
        if (isSandbox.value) {
          sandboxLogoutDialog.value = true;
        } else {
          await authenticationRepository.signOutUser(true);
        }
      } catch (e) {
        throw err(new CustomError(CustomError.Type.general, e, "HotelAdmin - logOutUser"));
      }
    };

    onCreated(async () => {
      currentMenu.value = $route.path.substring(`/${i18n.locale}/`.length);
      const staff = await userService.getCachedStaff();
      if (staff.isErr()) {
        return await new ErrorService().handleError(staff.error);
      }

      const tenantGroups = store.getters.staff.myself.tenant.location_groups;
      if (staff.value.myself.user.sandbox_type === "sandbox" && tenantGroups.length > 0) {
        isSandbox.value = true;
        await changeQrCode(getDefaultLocationGroup(tenantGroups).id);
      }
      accountName.value = staff.value.myself.user.name;
      tenantCd.value = staff.value.myself.tenant.code;
      // essentially just a function that currently contains a hard-coded menu structure (from hotelAdmin.ts)
      headerMenus.value = loadHeaderMenus(staff.value.myself.tenant);
      tenantName.value = userService.getTenantName(i18n.locale, staff.value.myself.tenant.names);
      // PO says not to display for sandbox, so don't even make the request
      if (!isSandbox.value) {
        const res = await tenantService.getDashboardUrl(staff.value.myself.tenant.id);
        if (res.isErr()) {
          return await errorService.handleError(res.error);
        }

        dashboardUrl.value = res.value;
      }
      watcherInterval = setInterval(async () => {
        // Temporary solution for checking if another user is importing an excel file or not
        await isImportInProgress();
      }, 5000);
    });

    const changeQrCode = async (groupId: number) => {
      const res = await tenantService.fetchLocation(groupId);
      if (res.isErr()) {
        return await errorService.handleError(res.error);
      }

      const locations = res.value;
      if (locations.length > 0) {
        locationQr.value = locations[0].qr || "";
        if (locations[0].hash_value) {
          const proxyString =
            isSamoon() && process.env.VUE_APP_KTZN_PROXY
              ? process.env.VUE_APP_KTZN_BH_PROXY
              : process.env.VUE_APP_KTZN_PROXY;
          const hashValue = locations && locations[0].hash_value ? locations[0].hash_value : "";
          guestUrl.value = proxyString + "biz/location/" + hashValue;
        }
        showLocQr.value = true;
      }
    };

    // this can be expanded upon later, in case PO's decide they want the "going to dif site" warning, etc
    const forwardTo = (url: string): void => {
      window.open(url, "_blank");
    };

    const closeNotification = () => {
      inProgressNotification.value = false;
    };

    // Check if importing dictionary-excel-file is in-progress by any other user or not
    const checkImportingProcess = async () => {
      let tenantId: any = "";
      if ((router.currentRoute.query && router.currentRoute.query.tenant_id) || store.getters.tenantId) {
        tenantId = store.getters.tenantId ? store.getters.tenantId : router.currentRoute.query.tenant_id;
      }
      if (!tenantId) {
        const res = await tenantService.fetchTenantInfo();
        if (res.isErr()) {
          await errorService.handleError(res.error);
          return;
        }

        const tenant: QueryTenant = res.value;
        tenantId = tenant.id;
      }

      const result = await new DictionaryService().importProcess(tenantId);
      if (result.isErr()) return await new ErrorService().handleError(result.error);

      return result.value;
    };

    const isImportInProgress = async () => {
      if (store.getters.getIsUserImportingToDictionary) {
        return;
      }
      const isImportingInProgress: ImportProcessResult | void = await checkImportingProcess();
      if (isImportingInProgress && isImportingInProgress.import_process) {
        // Another user is importing to the dictionary
        // Current user should not access to some menus + show a dialog for informing the user
        store.commit("SET_IS_IMPORT_IN_PROGRESS", true);
      } else {
        store.commit("SET_IS_IMPORT_IN_PROGRESS", false);
        inProgressNotification.value = false;
      }
    };

    const watcher = watch(
      () => store.getters.getIsImportInProgress,
      (newVal) => {
        if (newVal) {
          waitingForImportProcessByOthers.value = true;
          inProgressNotification.value = true;
        } else if (waitingForImportProcessByOthers.value) {
          waitingForImportProcessByOthers.value = false;
          importProgressNotification.value = true;
        }
      }
    );

    watch(
      () => store.getters.stopCheckingImportProcess,
      async (newVal) => {
        if (store.getters.stopCheckingImportProcess) {
          clearInterval(watcherInterval); // To kill the interval for checking the import process
          watcher();
          await store.commit("STOP_CHECKING_IMPORT_PROCESS", false);
        }
      }
    );

    watch(
      () => store.getters.currentGroupId,
      (newVal) => {
        // intentially left to occur synchronously in the background
        changeQrCode(newVal);
      }
    );

    onBeforeDestroy(() => {
      if (watcherInterval) {
        clearInterval(watcherInterval); // To kill the interval for checking the import process
        watcher(); // To kill the watcher for checking the import process
      }
    });

    return {
      sandboxLogoutDialogState,
      gotoEachMenu,
      proceed,
      isSandbox,
      headerMenus,
      currentMenu,
      dialog,
      dialogSignOut,
      dialogSystemError,
      hotelLogo,
      accountName,
      tenantName,
      locationQr,
      showLocQr,
      sandboxLogoutDialog,
      isLoading,
      isSaving,
      logOutSandBox,
      signOutAdmin,
      logOutUser,
      dialogState,
      closeNotification,
      checkMenuAvailability,
      forwardTo,
      importInprogressNotification,
      importProgressNotification,
      guestUrl,
      manualUrl,
      dashboardUrl,
      showLogoutDialog,
      showLogoutDialogState,
    };
  },
});
</script>

<style lang="scss" scoped>
.v-application p {
  margin-bottom: 0;
}

.activeMenu {
  text-decoration: underline;
  cursor: pointer;
}

.header_menu__wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.header_menu__item {
  -webkit-margin-end: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-menu__content > div {
  background-color: #424242;
}

.v-menu__content > div > .v-list-item > div {
  color: white;
}

.location_qr {
  position: absolute;
  top: 0;
  width: 135px;
  background: white;
  box-shadow: 0 0 0.4px 0.4px lightgray;
  min-height: 155px;
  height: fit-content;
  right: 0;
}

.location_qr-img:hover {
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.iconButton {
  background: white;
}

.headerRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: right;
}

.system-error-notice {
  position: relative;
  top: 50px; /* same as the height of the v-app-bar */
  left: 0;
  width: 100%;
  background-color: #ff8188;
}

.signout-button {
  color: white;
}

.layout-loader {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(33, 33, 33, 0.46);
  color: #fff;
  height: 100%;
  width: 100%;
  z-index: 3; // app bar is z-index 5
}
</style>
